<script>
import Layout from '@/router/layouts/main';
import textMixin from '../../../../mixins/textMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const SuppliersRepository = Repositories.get('suppliers');
import DeleteButton from '@/components/widgets/buttons/delete-button';
import GridComponent from '@/components/widgets/grids/pagination-grid';
import MultipleItems from '@/components/widgets/popovers/multiple-items';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Suppliers',
  },
  mixins: [textMixin],
  components: {
    Layout,
    Loading,
    DeleteButton,
    GridComponent,
    MultipleItems,
  },
  data() {
    return {
      isLoading: false,
      searchText: '',
      items: [
        {
          text: 'suppliers',
          href: '/suppliers',
        },
        {
          text: '',
          active: true,
        },
      ],
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      SuppliersRepository.getAll()
        .then((response) => {
          this.list = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    edit(idPublic) {
      this.$router.push({
        name: 'editSupplier',
        params: { idPublic: idPublic },
      });
    },
    create() {
      this.$router.push({ name: 'createSupplier' });
    },
    cancelSearch() {
      this.searchText = '';
    },
    remove(idPublic) {
      this.isLoading = true;
      SuppliersRepository.delete(idPublic)
        .then(() => {
          let foundIndex = this.list.findIndex((x) => x.idPublic == idPublic);
          this.list.splice(foundIndex, 1);
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
  },
  computed: {
    supplierLisComputed() {
      return this.list.filter((item) => {
        const name = item.name.toLowerCase();
        const searchTerms = this.searchText.toLowerCase().split(' ');
        let isValidElement = true;

        for (const x of searchTerms) {
          if (!name.includes(x)) {
            isValidElement = false;
          }
        }

        return isValidElement;
      });
    },
    fieldsComputed() {
      return [
        {
          key: 'name',
          label: this.$t('general.name'),
          sortable: true,
        },
        {
          key: 'contact',
          label: this.$t('suppliers.contact'),
          sortable: true,
        },
        {
          key: 'phone',
          label: this.$t('suppliers.phone'),
          sortable: true,
        },
        {
          key: 'email',
          label: this.$t('suppliers.email'),
          sortable: true,
        },
        {
          key: 'link',
          label: this.$t('general.link'),
          sortable: true,
        },
        {
          key: 'method',
          label: this.$t('suppliers.method'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'edit',
          label: this.$t('general.edit'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'delete',
          label: this.$t('general.delete'),
          class: 'centered-field',
          sortable: true,
        },
      ];
    },
  },
};
</script>

<template>
  <Layout :title="$t('suppliers.suppliers')">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div class="topbar">
      <b-form-group
        id="fieldset-1"
        :label="$t('general.search')"
        label-for="searchInput"
      >
        <b-form-input
          id="searchInput"
          type="text"
          style="min-width: 300px"
          :placeholder="$t('general.search')"
          @keydown.escape.prevent="cancelSearch()"
          v-model="searchText"
      /></b-form-group>

      <b-form-group id="fieldset-2" style="margin-left: auto">
        <b-button
          style="height: 40px; margin-top: 28px"
          @click="create()"
          variant="primary"
        >
          {{ $t('general.add') }}
        </b-button>
      </b-form-group>
    </div>

    <GridComponent
      id="supplier-grid"
      :fields="fieldsComputed"
      :items="supplierLisComputed"
    >
      <template #cell(name)="data">
        <div v-html="highlightMatches(data.value, searchText)"></div>
      </template>

      <template #cell(email)="data">
        <MultipleItems
          :list="data.value.split(';')"
          :uniqueId="data.item.idPublic"
        />
      </template>

      <template #cell(method)="data">
        {{
          data.item.method == 'phone'
            ? $t('suppliers.phoneLink')
            : data.item.method == 'pdf'
            ? $t('suppliers.emailPDF')
            : $t('suppliers.emailLink')
        }}
      </template>

      <template #cell(edit)="data">
        <i
          class="fas fa-pencil-alt text-success pl-2 pr-2"
          @click="edit(data.item.idPublic)"
          style="cursor: pointer; font-size: 1.3em"
        ></i>
      </template>

      <template #cell(delete)="data">
        <DeleteButton @clicked="remove(data.item.idPublic)" />
      </template>
    </GridComponent>
  </Layout>
</template>

<style scoped>
.topbar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>